
export default {
  name: 'UnitedStatesFlag',
};
